import type { User } from '../model/types';
import { loadJson, removeJson, saveJson, subscribeToJson } from './jsonStorage';

export const tokenKey = 'token';

export interface ExpiringValue {
    value: string;

    /**
     * This is not used anymore, the server will handle expired tokens
     */
    expiresAt?: never;
}

export interface Token {
    user: User | null;
    accessToken: ExpiringValue;
    refreshToken: ExpiringValue;
}

let currentToken: Token | null;

if (typeof window !== 'undefined') {
    // make sure `currentToken` updates when it is changed
    // in another tab. This prevents many logged out bugs!
    onTokenChange((token) => {
        currentToken = token;
    });
}

export function getToken(): Token | null {
    if (!currentToken) {
        currentToken = loadJson(tokenKey);
    }
    return currentToken;
}

export function setToken(accessToken: ExpiringValue, refreshToken: ExpiringValue): void {
    currentToken = {
        user: currentToken?.user ?? null,
        accessToken,
        refreshToken,
    };

    saveJson(tokenKey, currentToken);
}

export function setUser(user: User): void {
    if (!currentToken) throw new Error('Cannot set user without token');

    currentToken = {
        ...currentToken,
        user,
    };

    saveJson(tokenKey, currentToken);
}

export type Unsubscribe = () => void;

export function onTokenChange(onTokenChange: (token: Token | null) => void): Unsubscribe {
    return subscribeToJson<Token>(tokenKey, onTokenChange);
}

export function clearToken(): void {
    currentToken = null;
    removeJson(tokenKey);
}
